import { render } from "./FullScreenLoader.vue?vue&type=template&id=68b800d0"
import script from "./FullScreenLoader.vue?vue&type=script&lang=js"
export * from "./FullScreenLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__